var _desc, _defs, _g, _g2, _mask, _g3, _mask2, _path, _path2, _mask3, _g4, _g5, _mask4, _path3, _path4, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_1_707_dd",
    x: -3,
    y: 13,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.21569 0 0 0 0 0.40784 0 0 0 0 0.55686 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect_dropShadow_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect_dropShadow_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_1_708_dd",
    x: -11,
    y: -10,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.21569 0 0 0 0 0.40784 0 0 0 0 0.55686 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect_dropShadow_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect_dropShadow_1",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_1_707_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M30 60C42.15 60 52 50.15 52 38C52 25.84 42.15 16 30 16C17.84 16 8 25.84 8 38C8 50.15 17.84 60 30 60Z",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M52 38C52 25.84 42.15 16 30 16C17.84 16 8 25.84 8 38C8 50.15 17.84 60 30 60C42.15 60 52 50.15 52 38Z",
    stroke: "#38AEF5",
    strokeOpacity: 0,
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_1_708_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M30 60C46.56 60 60 46.56 60 30C60 13.43 46.56 0 30 0C13.43 0 0 13.43 0 30C0 46.56 13.43 60 30 60Z",
    fill: "#2196F3",
    fillOpacity: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M60 30C60 46.56 46.56 60 30 60C13.43 60 0 46.56 0 30C0 13.43 13.43 0 30 0C46.56 0 60 13.43 60 30ZM54.09 20.01Q56 24.61 56 30Q56 35.38 54.09 39.98Q52.19 44.57 48.38 48.38Q44.57 52.19 39.98 54.09Q35.38 56 30 56Q24.61 56 20.01 54.09Q15.42 52.19 11.61 48.38Q7.8 44.57 5.9 39.98Q4 35.38 4 30Q4 24.61 5.9 20.01Q7.8 15.42 11.61 11.61Q15.42 7.8 20.01 5.9Q24.61 4 30 4Q35.38 4 39.98 5.9Q44.57 7.8 48.38 11.61Q52.19 15.42 54.09 20.01Z",
    fill: "#42A5F5",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_709",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M30 60C46.56 60 60 46.56 60 30C60 13.43 46.56 0 30 0C13.43 0 0 13.43 0 30C0 46.56 13.43 60 30 60Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M2.71 22.87L56.53 22.87",
    stroke: "#42A5F5",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M2.71 38.62L56.53 38.62",
    stroke: "#42A5F5",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M29.25 4.5C29.25 4.5 19.28 16.07 19.5 30.75C19.71 45.42 29.25 55.5 29.25 55.5",
    stroke: "#42A5F5",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M30 4.5C30 4.5 39.96 16.07 39.74 30.75C39.53 45.42 30 55.5 30 55.5",
    stroke: "#42A5F5",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask_1_717",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M45.4347 19.7809C44.7983 18.6787 41.8657 18.762 40.8474 18.8259C40.6169 18.8405 40.3945 18.9124 40.1946 19.0278L34.0768 22.5599L19.7791 13.3367C19.5776 13.2068 19.319 13.1951 19.1115 13.3149L17.8389 14.0228C17.6727 14.1187 17.5533 14.2786 17.517 14.4669L17.3267 15.4504C17.2948 15.6152 17.3353 15.7816 17.4191 15.9266L25.0778 27.7554L18.6974 31.4392L14.3352 29.709C14.0314 29.5886 13.6853 29.7126 13.5273 29.9987L13.2865 30.4347C13.1647 30.6552 13.1815 30.9263 13.3295 31.1301L15.8929 34.6611C15.2429 35.702 14.7697 36.7578 15.0792 37.2939C15.389 37.8306 16.5439 37.9515 17.774 37.9122L19.5637 41.9282C19.6663 42.1583 19.8927 42.3083 20.1445 42.3132L20.6426 42.3226C20.9694 42.3288 21.2498 42.0912 21.2974 41.7678L21.9843 37.0963L28.3534 33.4191L34.8113 46.0508C34.8951 46.1959 35.0189 46.3143 35.1775 46.369L36.1244 46.696C36.3057 46.7586 36.5039 46.7352 36.67 46.6393L37.9193 45.8911C38.1268 45.7712 38.2461 45.5414 38.2343 45.302L37.3904 28.2016L43.4662 24.6938C43.666 24.5784 43.8394 24.4219 43.967 24.2297C44.5317 23.3805 46.071 20.8831 45.4347 19.7809Z",
    clipRule: "evenodd",
    fill: "",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M45.4347 19.7809C44.7983 18.6787 41.8657 18.762 40.8474 18.8259C40.6169 18.8405 40.3945 18.9124 40.1946 19.0278L34.0768 22.5599L19.7791 13.3367C19.5776 13.2068 19.319 13.1951 19.1115 13.3149L17.8389 14.0228C17.6727 14.1187 17.5533 14.2786 17.517 14.4669L17.3267 15.4504C17.2948 15.6152 17.3353 15.7816 17.4191 15.9266L25.0778 27.7554L18.6974 31.4392L14.3352 29.709C14.0314 29.5886 13.6853 29.7126 13.5273 29.9987L13.2865 30.4347C13.1647 30.6552 13.1815 30.9263 13.3295 31.1301L15.8929 34.6611C15.2429 35.702 14.7697 36.7578 15.0792 37.2939C15.389 37.8306 16.5439 37.9515 17.774 37.9122L19.5637 41.9282C19.6663 42.1583 19.8927 42.3083 20.1445 42.3132L20.6426 42.3226C20.9694 42.3288 21.2498 42.0912 21.2974 41.7678L21.9843 37.0963L28.3534 33.4191L34.8113 46.0508C34.8951 46.1959 35.0189 46.3143 35.1775 46.369L36.1244 46.696C36.3057 46.7586 36.5039 46.7352 36.67 46.6393L37.9193 45.8911C38.1268 45.7712 38.2461 45.5414 38.2343 45.302L37.3904 28.2016L43.4662 24.6938C43.666 24.5784 43.8394 24.4219 43.967 24.2297C44.5317 23.3805 46.071 20.8831 45.4347 19.7809Z",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd",
    mask: "url(#mask_1_717)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "",
    fill: "#979797",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_723",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5.692383,
    y: 3.512939,
    width: 49.181152,
    height: 50.139099
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask_1_723",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M45.4347 19.7809C44.7983 18.6787 41.8657 18.762 40.8474 18.8259C40.6169 18.8405 40.3945 18.9124 40.1946 19.0278L34.0768 22.5599L19.7791 13.3367C19.5776 13.2068 19.319 13.1951 19.1115 13.3149L17.8389 14.0228C17.6727 14.1187 17.5533 14.2786 17.517 14.4669L17.3267 15.4504C17.2948 15.6152 17.3353 15.7816 17.4191 15.9266L25.0778 27.7554L18.6974 31.4392L14.3352 29.709C14.0314 29.5886 13.6853 29.7126 13.5273 29.9987L13.2865 30.4347C13.1647 30.6552 13.1815 30.9263 13.3295 31.1301L15.8929 34.6611C15.2429 35.702 14.7697 36.7578 15.0792 37.2939C15.389 37.8306 16.5439 37.9515 17.774 37.9122L19.5637 41.9282C19.6663 42.1583 19.8927 42.3083 20.1445 42.3132L20.6426 42.3226C20.9694 42.3288 21.2498 42.0912 21.2974 41.7678L21.9843 37.0963L28.3534 33.4191L34.8113 46.0508C34.8951 46.1959 35.0189 46.3143 35.1775 46.369L36.1244 46.696C36.3057 46.7586 36.5039 46.7352 36.67 46.6393L37.9193 45.8911C38.1268 45.7712 38.2461 45.5414 38.2343 45.302L37.3904 28.2016L43.4662 24.6938C43.666 24.5784 43.8394 24.4219 43.967 24.2297C44.5317 23.3805 46.071 20.8831 45.4347 19.7809Z",
    clipRule: "evenodd",
    fill: "",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M45.4347 19.7809C44.7983 18.6787 41.8657 18.762 40.8474 18.8259C40.6169 18.8405 40.3945 18.9124 40.1946 19.0278L34.0768 22.5599L19.7791 13.3367C19.5776 13.2068 19.319 13.1951 19.1115 13.3149L17.8389 14.0228C17.6727 14.1187 17.5533 14.2786 17.517 14.4669L17.3267 15.4504C17.2948 15.6152 17.3353 15.7816 17.4191 15.9266L25.0778 27.7554L18.6974 31.4392L14.3352 29.709C14.0314 29.5886 13.6853 29.7126 13.5273 29.9987L13.2865 30.4347C13.1647 30.6552 13.1815 30.9263 13.3295 31.1301L15.8929 34.6611C15.2429 35.702 14.7697 36.7578 15.0792 37.2939C15.389 37.8306 16.5439 37.9515 17.774 37.9122L19.5637 41.9282C19.6663 42.1583 19.8927 42.3083 20.1445 42.3132L20.6426 42.3226C20.9694 42.3288 21.2498 42.0912 21.2974 41.7678L21.9843 37.0963L28.3534 33.4191L34.8113 46.0508C34.8951 46.1959 35.0189 46.3143 35.1775 46.369L36.1244 46.696C36.3057 46.7586 36.5039 46.7352 36.67 46.6393L37.9193 45.8911C38.1268 45.7712 38.2461 45.5414 38.2343 45.302L37.3904 28.2016L43.4662 24.6938C43.666 24.5784 43.8394 24.4219 43.967 24.2297C44.5317 23.3805 46.071 20.8831 45.4347 19.7809Z",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd",
    mask: "url(#mask_1_723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "",
    fill: "#979797",
    fillOpacity: 0,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_723)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 34.536011,
    y: 20.783813,
    width: 1.308532,
    height: 12.408354,
    transform: "rotate(60 34.536011 20.783813)",
    fill: "#EBECF2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 34.536011,
    y: 20.783813,
    width: 1.308532,
    height: 12.408354,
    transform: "rotate(60 34.536011 20.783813)",
    stroke: "#979797",
    strokeOpacity: 0,
    strokeWidth: 0
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5",
    d: "M37.91 45.89C38.12 45.76 38.24 45.54 38.23 45.3L37.36 27.64L28.12 32.97L34.81 46.05C34.88 46.2 35.01 46.31 35.17 46.36L36.12 46.69C36.3 46.75 36.5 46.73 36.66 46.63L37.91 45.89Z",
    fill: "#DEE1E3",
    fillOpacity: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5",
    d: "M37.36 27.64L28.12 32.97L34.81 46.05C34.89 46.19 35.01 46.31 35.17 46.36L36.12 46.69C36.3 46.75 36.5 46.73 36.66 46.63L37.91 45.89C38.12 45.77 38.24 45.54 38.23 45.3L37.36 27.64Z",
    stroke: "#979797",
    strokeOpacity: 0,
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_723)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      mixBlendMode: "normal"
    }
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask_1_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M17.8365 37.8013L17.7476 37.8527L19.5638 41.9282C19.6664 42.1584 19.8928 42.3084 20.1447 42.3132L20.6426 42.3226C20.9694 42.3288 21.2499 42.0912 21.2974 41.7678L22.0229 36.8334L21.5601 37.1007C21.4167 37.1835 21.2622 37.2454 21.1007 37.2814C20.5503 37.4042 19.1544 37.6951 17.8365 37.8013Z",
    clipRule: "evenodd",
    fill: "",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M17.8365 37.8013L17.7476 37.8527L19.5638 41.9282C19.6664 42.1584 19.8928 42.3084 20.1447 42.3132L20.6426 42.3226C20.9694 42.3288 21.2499 42.0912 21.2974 41.7678L22.0229 36.8334L21.5601 37.1007C21.4167 37.1835 21.2622 37.2454 21.1007 37.2814C20.5503 37.4042 19.1544 37.6951 17.8365 37.8013Z",
    clipRule: "evenodd",
    fill: "#DEE1E3",
    fillOpacity: 1,
    fillRule: "evenodd",
    mask: "url(#mask_1_731)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "",
    fill: "#979797",
    fillOpacity: 0,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_723)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask_1_734",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M28.2483 33.2135L37.3777 27.9426L37.4769 29.954L29.9561 36.5538L28.2483 33.2135Z",
    clipRule: "evenodd",
    fill: "",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M28.2483 33.2135L37.3777 27.9426L37.4769 29.954L29.9561 36.5538L28.2483 33.2135Z",
    clipRule: "evenodd",
    fill: "#C5C6CC",
    fillOpacity: 1,
    fillRule: "evenodd",
    mask: "url(#mask_1_734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "",
    fill: "#979797",
    fillOpacity: 0,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M46.48 22.95L16.69 40.15C16.69 40.15 15.81 38.56 15.07 37.29C15.07 37.27 15.06 37.26 15.05 37.24C16.4 37.34 19.12 37.23 21.76 35.71L42.39 23.8C44.68 22.48 45.24 20.76 45.55 20.03C46.03 21.31 46.48 22.95 46.48 22.95Z",
    fill: "#DEE1E3",
    fillOpacity: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    d: "M16.69 40.15C16.69 40.15 15.81 38.56 15.07 37.29C15.07 37.27 15.06 37.26 15.05 37.24C16.4 37.34 19.12 37.23 21.76 35.71L42.39 23.8C44.68 22.48 45.24 20.76 45.55 20.03C46.03 21.31 46.48 22.95 46.48 22.95L16.69 40.15Z",
    stroke: "#979797",
    strokeOpacity: 0,
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ed973225881cd7cc3525e7fe379362c4.svg";
export { ForwardRef as ReactComponent };